<template>
  <div>
    <div v-if="componentsShow" class="font-container">
      <div class="items">
        <v-card style="height: 180px">
          <div>
            <div class="title">
              <h3>logo图片</h3>
            </div>
            <input
              :value="!logoFile ? '选择图片' : '重新选择'"
              class="btn-text"
              type="button"
              @click="$refs.fileInput.click()"
            >

            <input
              ref="fileInput"
              style="display: none"
              accept="image/*"
              type="file"
              @change="fileChange"
            >
          </div>
          <!-- <v-card-title>
            <h2>logo图片</h2>
          </v-card-title> -->
          <!-- <v-card-text style="margin-top: -20px;"> -->
          <!-- <div class="image-container"> -->
          <!-- <img
              v-if="logoUrl"
              id="img"
              title="点击更换头像"
              class="mr-0 cursor_pointer"
              :src="logoUrl"
              alt="avatar"
              width="20%"
              height="auto"
              @click="showCutter=true"
            >
            <img
              v-else
              title="点击更换头像"
              width="20%"
              height="auto"
              class="mr-0 cursor_pointer"
              src="@/assets/head2.png"
              alt="avatar"
              @click="showCutter=true"
            > -->
          <!-- </div> -->
          <!-- <div
            class="btn-text"
            @click="onImgChangeClick"
          >
            {{ logoUrl|| '点击更换头像' }}
          </div> -->
          <!-- <input
            :value="!logoFile ? '选择图片' : '重新选择'"
            class="btn-text"
            type="button"
            @click="$refs.fileInput.click()"
          >
          <input
            ref="fileInput"
            style="display: none;"
            accept="image/*"
            type="file"
            @change="fileChange"
          > -->
          <!-- </v-card-text> -->
        </v-card>
      </div>
      <div class="items">
        <choose-font
          ref="companyNameEn"
          title="公司名称（英文）"
          :form-data="companyNameEnForm"
        />
      </div>
      <div class="items">
        <choose-font
          ref="systemNameEn"
          title="系统名称（英文）"
          :form-data="systemNameEnForm"
        />
      </div>
      <div class="items">
        <choose-font
          ref="systemNameCn"
          title="系统名称（中文）"
          :form-data="systemNameCnForm"
        />
      </div>
      <div class="items">
        <choose-font
          ref="systemDesc"
          title="系统简介"
          :form-data="systemDescForm"
        />
      </div>
      <div class="items">
        <choose-font
          ref="systemCopyRightInformation"
          title="版权信息"
          :form-data="systemCopyRightInformationForm"
        />
      </div>
      <div class="items">
        <v-card style="height: 180px">
          <div>
            <div class="title">
              <h3>小程序二维码</h3>
            </div>

            <input
              :value="!qrcode ? '选择图片' : '重新选择'"
              class="btn-text"
              type="button"
              @click="$refs.qrcodeInput.click()"
            >
            <input
              ref="qrcodeInput"
              style="display: none"
              accept="image/*"
              type="file"
              @change="qrcodeChange"
            >
          </div>
        </v-card>
      </div>
      <div class="items">
        <v-card style="height: 180px">
          <div>
            <div class="title">
              <h3>小程序头像</h3>
            </div>

            <input
              :value="!avatar ? '选择图片' : '重新选择'"
              class="btn-text"
              type="button"
              @click="$refs.avatarInput.click()"
            >
            <input
              ref="avatarInput"
              style="display: none"
              accept="image/*"
              type="file"
              @change="avatarChange"
            >
          </div>
        </v-card>
      </div>
      <div class="items" />
    </div>
    <div class="buttonBox">
      <v-btn
        color="primary"
        depressed
        class="mt-4"
        height="32"
        width="100"
        type="primary"
        :loading="loading"
        @click="onSave"
      >保存</v-btn>
    </div>
  </div>
</template>

<script>
import chooseFont from './chooseFont.vue';
export default {
  components: { chooseFont },
  data() {
    const form = {
      name: '',
      font: '',
      size: '',
      color: '',
    };
    return {
      componentsShow: false,
      companyNameEnForm: form,
      systemNameEnForm: form,
      systemNameCnForm: form,
      systemDescForm: form,
      systemCopyRightInformationForm: form,
      loading: false,
      logoUrl: '',
      showCutter: false,
      height: 0,
      logoFile: '',
      qrcode: '',
      qrcodeUrl: '',
      avatar: '',
    };
  },
  created() {
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      this.$http.get(this.$api.getPublicInfo).then((res) => {
        const data = res.result;
        const [
          companyNameEnFormName,
          companyNameEnFormNameForm,
          companyNameEnFormSize,
          companyNameEnFormColor,
        ] = data.companyNameEn.split(':');
        this.companyNameEnForm = {
          name: companyNameEnFormName,
          font: companyNameEnFormNameForm,
          size: companyNameEnFormSize,
          color: companyNameEnFormColor,
        };

        const [
          systemNameEnFormName,
          systemNameEnFormNameForm,
          systemNameEnFormSize,
          systemNameEnFormColor,
        ] = data.systemNameEn.split(':');
        this.systemNameEnForm = {
          name: systemNameEnFormName,
          font: systemNameEnFormNameForm,
          size: systemNameEnFormSize,
          color: systemNameEnFormColor,
        };

        const [
          systemNameCnFormName,
          systemNameCnFormNameForm,
          systemNameCnFormSize,
          systemNameCnFormColor,
        ] = data.systemNameCn.split(':');
        this.systemNameCnForm = {
          name: systemNameCnFormName,
          font: systemNameCnFormNameForm,
          size: systemNameCnFormSize,
          color: systemNameCnFormColor,
        };

        const [
          systemDescFormName,
          systemDescFormNameForm,
          systemDescFormSize,
          systemDescFormColor,
        ] = data.systemDesc.split(':');
        this.systemDescForm = {
          name: systemDescFormName,
          font: systemDescFormNameForm,
          size: systemDescFormSize,
          color: systemDescFormColor,
        };

        const [
          systemCopyRightInformationFormName,
          systemCopyRightInformationFormNameForm,
          systemCopyRightInformationFormSize,
          systemCopyRightInformationFormColor,
        ] = data.systemCopyRightInformation.split(':');
        this.systemCopyRightInformationForm = {
          name: systemCopyRightInformationFormName,
          font: systemCopyRightInformationFormNameForm,
          size: systemCopyRightInformationFormSize,
          color: systemCopyRightInformationFormColor,
        };
        this.logoUrl = data.logo;
        this.qrcodeUrl = data.prCode;
        this.componentsShow = true;
        setTimeout(() => {
          this.height = this.$refs.companyNameEn.$el.offsetHeight;
          console.log(this.height);
        }, 200);
      });
    },
    onSave() {
      // 拿传到子组件的formData的值
      const companyNameEnfFormData = this.$refs.companyNameEn.getFormData();
      const systemNameEnFormData = this.$refs.systemNameEn.getFormData();
      const systemNameCnFormData = this.$refs.systemNameCn.getFormData();
      const systemDescFormData = this.$refs.systemDesc.getFormData();
      const systemCopyRightInformationFormData =
        this.$refs.systemCopyRightInformation.getFormData();
      const form = new FormData();
      form.append(
        'companyNameEn',
        `${companyNameEnfFormData.name || ''}:${
          companyNameEnfFormData.font || ''
        }:${companyNameEnfFormData.size || ''}:${
          companyNameEnfFormData.color || ''
        }`
      );
      form.append(
        'systemNameEn',
        `${systemNameEnFormData.name || ''}:${
          systemNameEnFormData.font || ''
        }:${systemNameEnFormData.size || ''}:${
          systemNameEnFormData.color || ''
        }`
      );
      form.append(
        'systemNameCn',
        `${systemNameCnFormData.name || ''}:${
          systemNameCnFormData.font || ''
        }:${systemNameCnFormData.size || ''}:${
          systemNameCnFormData.color || ''
        }`
      );
      form.append(
        'systemDesc',
        `${systemDescFormData.name || ''}:${systemDescFormData.font || ''}:${
          systemDescFormData.size || ''
        }:${systemDescFormData.color || ''}`
      );
      form.append(
        'systemCopyRightInformation',
        `${systemCopyRightInformationFormData.name || ''}:${
          systemCopyRightInformationFormData.font || ''
        }:${systemCopyRightInformationFormData.size || ''}:${
          systemCopyRightInformationFormData.color || ''
        }`
      );
      if (this.logoFile) {
        form.append('file', this.logoFile);
      }
      if (this.qrcode) {
        form.append('qrCodeFile', this.qrcode);
      }
      if (this.avatar) {
        form.append('miniPhotoFile', this.avatar);
      }
      this.loading = true;
      this.$http
        .post(this.$api.savePublicInfo, { data: form })
        .then((res) => {
          this.init();
          this.$message.success('保存成功');
        })
        .finally(() => {
          this.loading = false;
          this.logoFile = '';
          this.qrcode = '';
        });
    },
    uploadAvatar(src) {
      const the = this;
      const imgElement = document.getElementById('img');
      imgElement.src = src;
      this.logoFile = src;
      this.$message.success('上传成功！');
      the.showCutter = false;
    },
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    fileChange(event) {
      // var formData = new FormData()
      // formData.append('file', event.target.files[0])
      this.logoFile = event.target.files[0];
      console.log(this.logoFile);
      event.target.value = '';
      this.$message.success('上传成功！');
    },
    qrcodeChange(event) {
      this.qrcode = event.target.files[0];
      console.log(this.qrcode);
      event.target.value = '';
      this.$message.success('上传成功！');
    },
    avatarChange(event) {
      this.avatar = event.target.files[0];
      console.log(this.avatar);
      event.target.value = '';
      this.$message.success('上传成功！');
    },
  },
};
</script>

<style scoped lang="scss">
// .font-container {
//   padding-left: 1%;
// }
// .font-container > * {
//   float: left;
//   width: 31%;
//   margin-right: 2%;
//   min-height: 170px;
//   margin-bottom: 10px;
// }
.item-img {
  display: flex;
  padding: 10px;
  align-items: center;
}
.title {
  padding: 16px 0 30px 16px;
}
.font-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px; /* 元素之间的间距 */
  align-items: stretch; /* 使子元素等高 */
}

.font-container > .items {
  flex: 1 1 calc(33.333% - 10px); /* 每个元素占据三分之一的宽度，减去间距 */
  box-sizing: border-box; /* 包括内边距和边框在内的宽度计算 */
  display: flex;
  flex-direction: column; /* 使子元素垂直排列 */
}
.buttonBox {
  width: 100%;
  text-align: center;
  margin-top: 20px;
}
.btn-text {
  display: block;
  margin: 0 auto;
  height: 40px;
  line-height: 40px;
  border: 1px solid #c7c7c7;
  width: 50%;
  padding: 0 5px;
  box-sizing: border-box; /* 确保内边距和边框不会影响宽度 */
  border-radius: 4px;
  overflow: hidden; /* 隐藏溢出的内容 */
  white-space: nowrap; /* 防止文本换行 */
  text-overflow: ellipsis; /* 显示省略号 */
  background-color: #f3f3f3;
  cursor: pointer;
}
.btn-text:hover {
  background-color: #e6e6e6;
}
.v-card,
.choose-font {
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* 根据需要调整内容的垂直对齐方式 */
}
</style>
